import * as React from 'react';
import './Loading.scss';

interface IProps {
    blockLevel: boolean;
    mini: boolean;
}

const LoadingPanel = (props : IProps) => {

    const bClass = props.blockLevel ? 'block-level' : '';
    const mClass = props.mini ? 'mini' : ''

    return <div id="loading-panel" className={`${ bClass } ${ mClass }`}>
        <div id="loading-indicator">
            <div className="folding-cube">
                <div className="cube-section1 cube-section" />
                <div className="cube-section2 cube-section" />
                <div className="cube-section4 cube-section" />
                <div className="cube-section3 cube-section" />
            </div>
            <p>loading</p>
        </div>
    </div>
}

LoadingPanel.defaultProps = {
    blockLevel: false,
    mini: false
}

export { LoadingPanel };
